import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {getAllProductCategoriesObject, printProductCategoryAccordion} from "./functions";
import {listToTree} from "../../assets/functions";
import "./styles.css";
import {Accordion} from "react-bootstrap";

const ProductCategories = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [productCategoriesTree, setProductCategoriesTree] = useState([]);

    useEffect(() => {
        (async () => {
            const productCategoriesObject = await getAllProductCategoriesObject();
            setProductCategoriesTree(listToTree(productCategoriesObject));
            document.title = "دسته بندی محصولات"
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">مدیریت دسته بندی محصولات</h1>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="accordion">
                                <Accordion alwaysOpen defaultActiveKey={[]}>
                                    {
                                        productCategoriesTree.map((productCategory, index) => {
                                            return (
                                                printProductCategoryAccordion(productCategory)
                                            );
                                        })
                                    }
                                </Accordion>
                            </div>


                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default ProductCategories;